import { z } from "zod";
/**
 * Telegram WebApp user shape per the Telegram Mini Apps spec
 * (https://core.telegram.org/bots/webapps#webappuser). Only the fields the
 * backend cares about are declared. Telegram delivers `id` as a JS number for
 * users with ids that fit in safe-integer range; the User row's
 * Postgres BIGINT column is fed via BigInt(...) on the backend side.
 */
export const telegramWebAppUserSchema = z.object({
    id: z.number().int().positive(),
    first_name: z.string().min(1),
    last_name: z.string().optional(),
    username: z.string().optional(),
    language_code: z.string().optional(),
    is_premium: z.boolean().optional(),
    allows_write_to_pm: z.boolean().optional(),
    photo_url: z.string().url().optional(),
});
/**
 * POST /api/auth/initdata + /api/auth/refresh request body. The frontend pulls
 * `Telegram.WebApp.initData` (a URL-encoded query string) and forwards it
 * verbatim. The backend validates the HMAC and re-issues a JWT.
 */
export const authInitDataRequestSchema = z.object({
    initData: z.string().min(1),
});
/**
 * The User shape echoed back to the Mini App after a successful auth. Keeps
 * the Telegram-side identifiers as strings — `telegramId` is a Postgres BIGINT
 * column and serializes through JSON as a string to avoid precision loss for
 * very large ids (Telegram is creeping past 2^53).
 */
export const authUserSchema = z.object({
    id: z.string().min(1),
    telegramId: z.string().regex(/^\d+$/),
    firstName: z.string(),
    username: z.string().nullable(),
    languageCode: z.string().nullable(),
    timezone: z.string(),
});
/**
 * Successful auth response. The JWT carries `userId` + `telegramId`; the
 * `expiresAt` field is the millisecond Unix timestamp of token expiry so the
 * frontend can schedule refresh without parsing the JWT itself.
 */
export const authResponseSchema = z.object({
    token: z.string().min(1),
    expiresAt: z.number().int().positive(),
    user: authUserSchema,
});
//# sourceMappingURL=auth.js.map